(function () {
  'use strict';

  function init() {
    var body = document.querySelector('[data-cart-drawer-body]');
    var subdrawer = document.getElementById('cart-bag-subdrawer');
    if (!subdrawer) return;

    var closeBtn = subdrawer.querySelector('[data-bag-subdrawer-close]');
    var seeAllBtn = subdrawer.querySelector('[data-bag-see-all]');
    var cartDrawerEl = document.querySelector('cart-drawer');

    var CART_ROOT = (function () {
      var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (typeof r === 'string' && (r === '/' || /^\/[^/]/.test(r))) return r;
      return '/';
    })();

    // Delegate prompt clicks from body — survives _swapBody since listener is on the div, not its children.
    if (body) {
      body.addEventListener('click', function (e) {
        if (e.target.closest('[data-bag-subdrawer-open]')) {
          openSubdrawer();
        }
      });
    }

    // Add-to-cart buttons inside the subdrawer — AJAX, no form submit.
    subdrawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bag-add-btn]');
      if (!btn) return;
      e.preventDefault();
      addBagToCart(btn);
    });

    closeBtn && closeBtn.addEventListener('click', closeSubdrawer);

    seeAllBtn && seeAllBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var href = this.getAttribute('href');
      closeSubdrawer(function () {
        if (cartDrawerEl && typeof cartDrawerEl.close === 'function') {
          cartDrawerEl.close();
        }
        setTimeout(function () {
          window.location.href = href;
        }, 320);
      });
    });

    // Escape closes subdrawer
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && subdrawer.getAttribute('aria-hidden') !== 'true') {
        closeSubdrawer();
      }
    });

    // Auto-close subdrawer when main cart drawer closes
    if (cartDrawerEl) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'class' && !cartDrawerEl.classList.contains('is-open')) {
            closeSubdrawer();
          }
        });
      });
      observer.observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
    }

    function addBagToCart(btn) {
      var variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;

      var originalText = btn.textContent;
      btn.disabled = true;

      var fd = new FormData();
      fd.set('id', variantId);
      fd.set('quantity', '1');

      fetch(CART_ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: fd,
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          btn.classList.add('is-done');
          // Silently refresh cart count + drawer body without opening anything.
          if (cartDrawerEl && typeof cartDrawerEl._refreshDrawer === 'function') {
            cartDrawerEl._refreshDrawer();
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    }

    function openSubdrawer() {
      subdrawer.setAttribute('aria-hidden', 'false');
      subdrawer.classList.add('is-open');
      requestAnimationFrame(function () {
        closeBtn && closeBtn.focus();
      });
    }

    function closeSubdrawer(callback) {
      subdrawer.classList.remove('is-open');
      subdrawer.setAttribute('aria-hidden', 'true');
      if (typeof callback === 'function') {
        setTimeout(callback, 380);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
